
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsPriceOverrideTranGrid extends Serenity.EntityGrid<PsPriceOverrideTranRow, any> {
        protected getColumnsKey() { return PsPriceOverrideTranColumns.columnsKey; }
        protected getDialogType() { return PsPriceOverrideTranDialog; }
        protected getIdProperty() { return PsPriceOverrideTranRow.idProperty; }
        protected getInsertPermission() { return PsPriceOverrideTranRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPriceOverrideTranRow.localTextPrefix; }
        protected getService() { return PsPriceOverrideTranService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
			var button = super.getButtons();

            button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
            
            button.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PsPriceOverrideTranService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			// button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}
    }
}